import { NavLink } from 'react-router'
import { cn } from '@/lib/utils'
import type { Municipio } from '@/api/modelos'
import { rutaDeSeccion, seccionesVisibles } from './secciones'

/**
 * La navegacion del panel, filtrada por los permisos del usuario EN este
 * municipio. Ocultar no protege: cada endpoint autoriza en el servidor.
 */
export default function Navegacion({
  municipio,
  alNavegar,
}: {
  municipio: Municipio
  alNavegar?: () => void
}) {
  const secciones = seccionesVisibles(municipio)

  return (
    <nav aria-label="Secciones del panel" className="flex flex-col gap-1 p-3">
      {secciones.map((seccion) => (
        <NavLink
          key={seccion.ruta}
          to={rutaDeSeccion(municipio.slug, seccion.ruta)}
          end={seccion.ruta === ''}
          onClick={alNavegar}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors outline-none',
              'focus-visible:ring-3 focus-visible:ring-ring/50',
              isActive
                ? 'bg-sidebar-accent font-medium text-sidebar-accent-foreground'
                : 'text-muted-foreground hover:bg-sidebar-accent/60 hover:text-foreground',
            )
          }
        >
          <seccion.icono className="size-4" aria-hidden="true" />
          {seccion.titulo}
        </NavLink>
      ))}
    </nav>
  )
}
